import { render, staticRenderFns } from "./TrapezSSL.vue?vue&type=template&id=41507470&"
import script from "./TrapezSSL.vue?vue&type=script&lang=js&"
export * from "./TrapezSSL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports